var map = {
	"./icons-arrow-down-dark.svg": "36cf",
	"./icons-arrow-down.svg": "9773",
	"./icons-arrow-up-dark.svg": "ded7",
	"./icons-arrow-up.svg": "a275"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35f8";